import { Box, Button, Typography } from "@mui/material";
import React, { useContext, useState } from "react";
import { ThemeContext, themes } from "../../utils/themes/ThemeContext";
import { IoMdSunny, IoMdMoon } from 'react-icons/io';
import { useNavigate } from "react-router-dom";

const Header = () => {
    const [hovered, setHovered] = useState(false);
    const {theme, toggleTheme} = useContext(ThemeContext);
    const navigate = useNavigate();

    return (
        <Box sx={{position: "fixed", top: 0, left: 0, width: "90vw", zIndex: 1100, paddingX: "5vw", display: "flex", flexWrap: "wrap", flexDirection: "row", justifyContent: "space-between", alignItems: "center", textAlign: "center", backgroundColor: theme.NeutralColor, py: "20px", borderBottom: `1px solid ${theme.SecondaryColor}`}}>
            <Box sx={{display: "flex", flexDirection: "row", alignItems: "center", textDecoration: "none"}}>
                <Box
                    onClick={() => navigate(`/`)}
                    onMouseEnter={() => setHovered(true)}
                    onMouseLeave={() => setHovered(false)}
                    component="img"
                    sx={{width: 50,
                        marginRight: "5vw",
                        cursor: "pointer",
                        transition: "transform 0.25s ease",
                        transform: hovered ? "scale(1.1) rotate(10deg)" : "translateY(0) scale(1) rotate(0)",}}
                    alt="Hotornot logo"
                    src={"/favicon.ico"}
                />
                <Typography sx={{fontFamily: "Poppins", display: { xs: "none", md: "block" }, fontSize: 30, fontWeight: "bold", color: theme.AccentColor}}>FACEMASH... is back?</Typography>
            </Box>
            <Box sx={{display: "flex", flexWrap: "wrap", flexDirection: "row", alignItems: "center"}}>
                <Button onClick={toggleTheme} style={{backgroundColor: "transparent", color: theme.PrimaryColor, textTransform: "none", fontSize: 15, margin: "10px", minWidth: "auto", padding: "8px"}}>
                    {theme === themes.dark ? <IoMdSunny size={20} /> : <IoMdMoon size={20} />}
                </Button>
            </Box>
        </Box>
    )
}

export default Header;